import createContext from 'bz-utilities/hooks/context-v2';
import { Provider } from 'mobx-react';
import type { TakePaymentRequest } from 'tm3-core/api.dtos';
import ClearAcceptStore from './store';

export const [ClearAcceptPaymentContext, useClearAcceptPaymentContext] =
  createContext<TakePaymentRequest | null>('ClearAcceptPaymentContext');

const store = new ClearAcceptStore();

export default function ClearAcceptProvider({ children }) {
  return <Provider clearAcceptStore={store}>{children}</Provider>;
}
